module.exports = __webpack_public_path__ + "img/section2_icon1.177436ad.svg";